export type TelegramAgentPermissions = {
  readMessages: boolean;
  sendMessages: boolean;
  createDocuments: boolean;
  indexRag: boolean;
  postToClickUp: boolean;
};

export const DEFAULT_TELEGRAM_AGENT_PERMISSIONS: TelegramAgentPermissions = {
  readMessages: false,
  sendMessages: false,
  createDocuments: false,
  indexRag: false,
  postToClickUp: false,
};

export interface TelegramConnectionStatus {
  connected: boolean;
  phone?: string;
  name?: string;
  avatarUrl?: string;
  agentPermissions?: TelegramAgentPermissions;
}

export interface TelegramChat {
  id: string;
  title: string;
  type?: string;
  unreadCount?: number;
  lastMessageDate?: string;
  lastMessagePreview?: string;
}

export interface TelegramMessage {
  id: string;
  chatId: string;
  subject: string;
  from: string;
  to?: string;
  date: string;
  preview: string;
  body?: string;
  read?: boolean;
}

export interface TelegramListParams {
  limit?: number;
  offsetId?: number;
  query?: string;
}

export interface TelegramSendInput {
  chatId: string;
  text: string;
}
